import React, {
  useEffect, useState, useRef,
} from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { WarningOutlined } from '@ant-design/icons';
import { getConfig, getStyle } from './utils/getConfig';
import Preloader from './components/preload';
import Scene from './components/scene/scene';
import { resetTicket } from './store/actions';
import Store from './store/store';
import { resetScanPolicyStore } from '../../../logic/store/pullstate/scanPolicy';
import Header from './components/Header';
import ExtraInfo from './components/Extra';

const { dispatch } = Store;

function App({ screen, ...props }) {
  const { oldConfig, id } = props;
  const { style, config } = useSelector((state) => state);
  const { startScreen, headUrl } = config;
  const { errorText } = config;
  const [notZoneId, setNotZoneId] = useState(false);
  const timer = useRef(false);
  const [alertActive, setAlertActive] = useState(false);
  const [alertType, setAlertType] = useState('Внимание!');
  const [alertText, setAlertText] = useState('Важное сообщение');
  const {
    head, header, extraText, phone, clock, logoABT, logoComp, footer, time, headerMain, headerSub,
  } = style;
  const location = useLocation();
  const navigate = useNavigate();

  const dragStart = (e) => e.preventDefault();

  const fetchAlertStatus = async () => {
    try {
      const res = await axios.post('/server/public/globalWarningStatus', { data: {} });
      const payload = res?.data;

      const statusTrue = payload?.status === 'true' || payload?.status === true;

      if (statusTrue) {
        setAlertActive(true);
        if (payload?.data) {
          const newType = payload.data.message_type || 'Внимание!';
          const newText = payload.data.message_text || 'Важное сообщение';
          setAlertType(newType);
          setAlertText(newText);
        }
      } else {
        setAlertActive(false);
      }
    } catch (e) {
      // тихо игнорируем ошибки
    }
  };

  const goToStart = () => {
    if (oldConfig) return;
    clearTimeout(timer.current);
    if (startScreen) {
      timer.current = setTimeout(() => {
        const { pathname } = location;
        if (errorText !== 'Отсутствует соединение с сервером' && pathname !== startScreen) {
          navigate(startScreen);
          dispatch(resetTicket());
        }
        goToStart();
        resetScanPolicyStore();
        localStorage.removeItem('emulatePreRecord');
        navigate(startScreen);
      }, 60 * 2 * 1000);
    }
  };

  useEffect(() => {
    if (oldConfig) getStyle({ style: oldConfig.config.style });
  }, [oldConfig]);

  useEffect(() => {
    goToStart();
  }, [errorText, startScreen]);

  useEffect(() => {
    fetchAlertStatus();
    const alertTimer = setInterval(fetchAlertStatus, 10000);
    return () => clearInterval(alertTimer);
  }, []);

  useEffect(() => {
    getConfig({
      id, dataProps: oldConfig, setNotZoneId, navigate, location,
    });
    document.body.addEventListener('dragstart', dragStart);
    document.body.addEventListener('click', goToStart);
    return () => {
      document.body.removeEventListener('dragstart', dragStart);
      document.body.removeEventListener('click', goToStart);
      clearTimeout(timer);
    };
  }, []);

  if (logoABT) delete logoABT.backgroundImage;
  const st = { backgroundSize: 'cover', backgroundRepeat: 'no-repeat' };
  if (head && config.config && !notZoneId) {
    const bodyHeight = style.head.height - header.height - footer.height;
    return (
      <div
        className="layout_box"
        style={{
          width: style.head.width, height: style.head.height, fontFamily: style.head.fontFamily, backgroundImage: `url(${style.head.backgroundImage})`,
        }}
      >
        <Header header={header} headerMain={headerMain} headerSub={headerSub} />

        <ExtraInfo
          extraText={extraText}
          clock={clock}
          time={time}
          phone={phone}
          logoABT={logoABT}
          logoComp={logoComp}
        />

        {headUrl && startScreen && (
          <Scene
            height={bodyHeight}
            config={config.config}
            satelliteParams={{ satelliteId: config.satelliteId, satellitePort: config.satellitePort }}
            startScreen={startScreen}
            headUrl={headUrl}
            selectScreen={screen}
            id={id}
            params={config.defaultParams}
            style={style}
          />
        )}
        {!startScreen && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              fontSize: 'large',
              fontWeight: 'bold',
            }}
          >
            Стартовый экран не указан
          </div>
        )}
        <div style={{ ...footer, st }} />

        {alertActive && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 9999,
            }}
          >
            <div
              style={{
                position: 'relative',
                border: '4px solid #ff4d4f',
                background: '#fff1f0',
                color: '#a8071a',
                padding: '40px 40px 40px 160px',
                borderRadius: 16,
                minHeight: 200,
                maxWidth: '90%',
                minWidth: '70%',
              }}
            >
              <WarningOutlined
                style={{
                  position: 'absolute',
                  left: 40,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  fontSize: 80,
                  color: '#a8071a',
                }}
              />
              <div style={{ fontWeight: 700, marginBottom: 16, fontSize: 36 }}>
                {alertType}
              </div>
              <div style={{ whiteSpace: 'pre-wrap', fontSize: 28, lineHeight: 1.6 }}>
                {alertText}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
  return <Preloader notZoneId={notZoneId} />;
}

export default App;
